import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ParamMap, Router, ActivatedRoute } from '@angular/router';
import { Company } from 'src/app/entities/company';
import { CompanyService } from 'src/app/services/company.service';
import { ServiceService } from 'src/app/services/service.service';
import { CsvListService } from 'src/app/services/csvList.service';
import { Service } from 'src/app/entities/service';
import { CsvMappingFields } from 'src/app/entities/csvMappingFields';
import { Subject } from 'rxjs';
import { PagerDataObject } from 'src/app/entities/pagerDataObject';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProcessService } from 'src/app/services/process.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SharedService } from 'src/app/services/sharedService';
import {CompanyFormComponent} from "../company-form.component";
import {AdminService} from "../../../services/admin.service";
import {DocumentService} from "../../../services/document.service";
import {saveAs} from 'file-saver';
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'app-company-add-edit',
    templateUrl: './company-add-edit.component.html',
    styleUrls: ['./company-add-edit.component.css']
})
export class CompanyAddEditComponent implements OnInit {
    filterForm: UntypedFormGroup;
    from = 0;
    to = 0;
    bigTotalItems = 0;
    bigCurrentPage = 1;
    currentPage = 1;
    numPages = 1;
    maxSize = 50;
    company: Company = new Company();
    submitted = false;
    wrongCurrentPassword = false;
    usernameExists = false;
    pass1 = ""
    pass2 = ""
    currentPassword: string;
    pass1Wrong = false;
    pass2Wrong = false;
    noPass = false;
    changePass = false;
    datasets;
    subscription: any;
    currentFileFormatId: any;
    service: Service = new Service();
    metaInfo: string[];
    columns: Array<any>;
    startLoading: boolean = false;
    modalRef?: BsModalRef;
    data: PagerDataObject;
    query: String;
    processes
    allControlsFlat = []
    allControlsFetchSize = 1000
    controlsData
    controlsColumns = [
        { key: 'controlCode', tag: 'CONTROL-MODULE.COL_CODE', filtering: false, sorting: false },
        { key: 'verifyPeriod', tag: 'CONTROL-MODULE.DERNIERE_PERIODE_VERIFIEE', filtering: false, sorting: false },
        { key: 'submitPeriod', tag: 'CONTROL-MODULE.PERIODE_SOUMISE_A_VERIFICATION', filtering: false, sorting: false },
        { key: 'controlType', tag: 'CONTROL-MODULE.CONTROL_TYPE', filtering: false, sorting: false },
        { key: 'controlStep', tag: 'CONTROL-MODULE.CONTROL_STEP', filtering: false, sorting: false,
            colorMap: { PROGRAMMATION: 'step-programmation', EVALUATION: 'step-evaluation', EXECUTION: 'step-execution' } }
    ]
    controlsMetaInfo = ['controlCode', 'verifyPeriod', 'submitPeriod', 'controlType', 'controlStep']
    totalCount = 0;
    respProcesses: any;
    private dataSub$ = new Subject<any>();
    taxIdColumn
    @ViewChild('editForm', { static: true })
    public editForm:CompanyFormComponent

    controlsModuleEnabled = false
    documents = []
    user
    loadingDatasetId: any = null
    selectedDatasetId: any = null

    onCompanySaved(company: Company): void {
        // Refresh the profile from the server after an edit (no full page reload).
        if (company && company.id) {
            this.companyService.getCompany('' + company.id).subscribe(c => {
                if (c) {
                    this.company = c;
                }
            });
        }
    }

    ngOnInit(): void {
        this.company = new Company();
        this.route.paramMap.pipe(
            switchMap((params: ParamMap) => this.companyService.getCompany(params.get('id'))))
            .subscribe(company => {
                if (company) {
                    this.company = company;
                    this.loadDocuments();
                    this.companyService.getDatasets(this.company.tax_id).subscribe(datasets => {
                        this.datasets = datasets
                        if (datasets && datasets.length > 0) {
                            var serviceId = datasets[0]._id
                            var fileFormatId = datasets[0].file_format_id
                            this.loadingDatasetId = fileFormatId;
                            this.serviceService.getService(serviceId)
                                .subscribe(service => {
                                    this.columns = [];
                                    this.service = service;
                                    if (this.service.fileFormats && this.service.fileFormats.length > 0) {
                                        this.currentFileFormatId = fileFormatId;
                                        var currentFileFormat = this.service.fileFormats.find(item => item['id'] == this.currentFileFormatId)
                                        currentFileFormat['mappingObjects'].forEach((mo) => {
                                            if (mo.type === '7') {
                                                this.taxIdColumn = mo.name
                                            }
                                            if (mo.type && mo.type !== 1)
                                                this.columns.push({
                                                    name: mo.name,
                                                    tag: mo.name,
                                                    key: mo.name,
                                                    description: mo.description,
                                                    filtering: mo.type === '7' ? false : true,
                                                    sorting: true,
                                                    sortingOrder: 'asc',
                                                    type: mo.type,
                                                    isNumber: CsvMappingFields.isAmountColumn(mo)
                                                });
                                        })
                                    }

                                    this.startLoading = true;
                                    this.loadingDatasetId = null;
                                    this.selectedDatasetId = fileFormatId;
                                    this.dataSub$.next(this.buildInitialQuery() + '&' + this.taxIdColumn + '=' + this.company.tax_id);
                                });
                        }
                        this.processService.getMyProposals(this.company.id, this.from, this.maxSize,
                            null, this.filterForm.value.search).subscribe(processes => {
                                this.to = processes.records.length;
                                this.respProcesses = processes
                                this.processes = processes.records;
                                this.totalCount = processes.total;
                                this.setupPaginator();
                            });
                        this.loadAllControls();
                    }
                    )

                }
            });

        this.sharedService.addProcessEventEmitter.subscribe(teamId => {
            this.fireQueryEvent();
            this.loadAllControls();
        });
    }
    setupPaginator(): void {
        this.bigTotalItems = this.totalCount = this.respProcesses.total;
        if (this.currentPage === 1) {
            if (this.respProcesses.total > 0) {

            }
            this.to = this.respProcesses.total < (this.maxSize + 1) ? this.respProcesses.total : this.maxSize;
        }
    }

    loadDocuments(){
        this.documentService.list$('payee', this.company.id).subscribe(documents => {
            this.documents = documents;
        })
    }

    constructor(public companyService: CompanyService,
                private router: Router, private route: ActivatedRoute,
                private serviceService: ServiceService,
                private csvListService: CsvListService,
                private modalService: BsModalService,
                private sharedService: SharedService,
                private processService: ProcessService,
                private settings: AdminService,
                private documentService: DocumentService,
                private alertService: ToastrService,
                public userService: UserService) {
        this.metaInfo = [];
        this.columns = [];
        this.filterForm = new UntypedFormGroup({
            search: new UntypedFormControl()
        });
        this.settings.modules$().subscribe(configuration => {
            this.controlsModuleEnabled = configuration?.modules?.controls ?? false;
        })
        this.subscription = this.dataSub$.pipe(switchMap(filter => {
            return this.csvListService.getData(filter + '&serviceId=' + this.service.id + ((this.currentFileFormatId === undefined) ? "" : '&fileFormatId=' + this.currentFileFormatId));
        })).subscribe(data => {
            this.data = data;
            this.startLoading = false;
            if (this.service.fileFormats && data?.records?.length > 0)
                this.metaInfo = Object.keys(data.records[0]);
        });
        this.loadData()
    }

    onGridQuery(query) {
        this.query = query
        this.dataSub$.next(query + "&" + this.taxIdColumn + "=" + this.company.tax_id);
    }
    loadFormat(serviceId, fileFormatId) {
        this.loadingDatasetId = fileFormatId;
        this.serviceService.getService(serviceId)
            .subscribe(service => {
                this.service = service;
                this.startLoading = true;
                this.loadingDatasetId = null;
                this.selectedDatasetId = fileFormatId;
                this.currentFileFormatId = fileFormatId;
                this.columns = [];
                if (this.service.fileFormats && this.service.fileFormats.length > 0) {
                    const currentFileFormat = this.service.fileFormats.find(item => item['id'] == this.currentFileFormatId);
                    if (currentFileFormat) {
                        currentFileFormat['mappingObjects'].forEach((mo) => {
                            if (mo.type === '7') {
                                this.taxIdColumn = mo.name;
                            }
                            if (mo.type && mo.type !== 1) {
                                this.columns.push({
                                    name: mo.name,
                                    tag: mo.name,
                                    key: mo.name,
                                    description: mo.description,
                                    filtering: mo.type === '7' ? false : true,
                                    sorting: true,
                                    sortingOrder: 'asc',
                                    type: mo.type
                                });
                            }
                        });
                    }
                }
                this.dataSub$.next(this.buildInitialQuery() + '&' + this.taxIdColumn + '=' + this.company.tax_id);
            });
    }

    onSubmit() {
        this.company['user_update'] = true
        if (!this.company.id) {
            this.company['password'] = this.pass1
        }
        this.companyService.add$(this.company)
            .subscribe(user => {
                if (user['error'] && user['error'] === 'USERNAME_EXISTS') {
                    this.usernameExists = true;
                }
                else {
                    this.submitted = true;

                    this.goToList();
                }

            });
    }

    goToList() {
        this.router.navigateByUrl('/company');
    }

    newProcess(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    changePage(event) {
        if (!isNaN(event)) {
            this.from = (event - 1) * this.maxSize;
            this.to = this.maxSize
            this.setPage(event);
        }
    }

    setPage(pageNo: number): void {

        this.currentPage = pageNo;
        this.fireQueryEvent();
    }

    fireQueryEvent() {
        this.processService.
            getMyProposals(this.company.id, this.from, this.maxSize,
                null, this.filterForm.value.search)
            .subscribe(processes => {
                this.to = processes.records.length;

                this.respProcesses = processes;
                this.processes = processes.records;
                this.totalCount = processes.total;
                this.setupPaginator();
            });
    }

    loadAllControls() {
        this.processService.getMyProposalsAll(this.company.id, 0, this.allControlsFetchSize, null, null)
            .subscribe({
                next: processes => {
                    const records = Array.isArray(processes) ? processes : (processes?.records ?? []);
                    this.allControlsFlat = records.map(p => this.flattenControl(p));
                    this.showControlsPage(0, this.maxSize);
                },
                error: () => {
                    this.allControlsFlat = [];
                    this.controlsData = { records: [], total: 0 };
                }
            });
    }

    onControlsQuery(query: any) {
        const raw = typeof query === 'string' ? query : query?.query ?? '';
        const params = new URLSearchParams(raw.indexOf('?') === 0 ? raw.substring(1) : raw);
        const from = Number(params.get('from')) || 0;
        const size = Number(params.get('size')) || this.maxSize;
        this.showControlsPage(from, size);
    }

    private showControlsPage(from: number, size: number) {
        this.controlsData = {
            records: this.allControlsFlat.slice(from, from + size),
            total: this.allControlsFlat.length
        };
    }

    flattenControl(process: any) {
        return {
            controlCode: process?.uniqueId ?? '',
            verifyPeriod: this.formatDateRange(process?.lastPeriod),
            submitPeriod: this.formatDateRange(process?.submittedPeriod),
            controlType: process?.type?.name ?? '',
            controlStep: process?.task?.step ?? ''
        };
    }

    formatDateRange(period: any): string {
        if (!period) {
            return '';
        }
        const parts = [this.formatDate(period.fromDate), this.formatDate(period.toDate)].filter(v => v);
        return parts.join(' - ');
    }

    formatDate(value: any): string {
        const raw = value && value.$date !== undefined ? value.$date : value;
        if (!raw) {
            return '';
        }
        const d = new Date(raw);
        if (isNaN(d.getTime())) {
            return '';
        }
        const day = ('0' + d.getUTCDate()).slice(-2);
        const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
        return day + '/' + month + '/' + d.getUTCFullYear();
    }

    downloadDocument(document) {
        this.documentService.get$(document.id).subscribe(data => {
            const file = new Blob([data], {});
            const filename = 'document-' + document.originalname
            saveAs(file, filename);
        });
    }

    deleteDocument(id) {
        const confirm = window.confirm("Are you sure you want to delete this document?");
        if (confirm){
            this.documentService.delete$(id).subscribe(
                () => {
                    this.alertService.success("Document deleted successfully");
                    this.loadDocuments();
                }
            )
        }
    }

    private buildInitialQuery(): string {
        let q = '?q=&';
        for (const col of this.columns) {
            if (col.filtering) {
                q += encodeURIComponent(col.key) + '=&';
            }
        }
        const sortCol = this.columns.find(c => c.sorting && c.sortingOrder);
        if (sortCol) {
            q += 'sort=' + encodeURIComponent(sortCol.key) + ':' + (sortCol.sortingOrder === 'desc' ? -1 : 1) + '&';
        }
        q += 'from=0&size=10';
        return q;
    }

    loadData() {
        this.userService.getCurrentUser().subscribe(user => {
            this.user = user;
        });
    }
}
